import { render, staticRenderFns } from "./TheFourHorsemenComponent.vue?vue&type=template&id=4242d8e7&"
import script from "./TheFourHorsemenComponent.vue?vue&type=script&lang=js&"
export * from "./TheFourHorsemenComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports